module.exports = __webpack_public_path__ + "img/dashboard.9c83a5ca.png";